/**
 * Service: groupsApi
 */
angular.module('acme.common.service.groupsApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('GroupsApiService', [ '$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/rbac/user/groups';
        this.roles.service = this.service;
        this.users.service = this.service;
        this.userMaps.service = endpoint + '/rbac/user/group/map';
        this.roleMaps.service = endpoint + '/rbac/user/group/roles';
        return this;
      },

      list: function(props) {
        var q = '';

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }
        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + q
        });
      },

      detail: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id
        });
      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      },

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: {
            name: props.name,
            displayName: props.displayName
          }
        });
      },

      update: function(props) {
        return $http({
          method: 'put',
          url: this.service,
          data: {
            id: props.id,
            name: props.name,
            displayName: props.displayName
          }
        });
      },

      users: {
        service: '',

        list: function(id, props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + '/' + id + '/users' + q
          });
        }

      },
      
      roles: {
        service: '',

        list: function(id, props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + '/' + id + '/roles' + q
          });
        }
      },

      userMaps: {
        service: '',

        list: function(props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        },

        remove: function(props) {
          return $http({
            method: 'delete',
            url: this.service,
            data: props.ids
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: [{
              userId: props.userId,
              userGroupId: props.userGroupId
            }]
          });
        },

        batchCreate: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: props.mappings
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service,
            data: {
              id: props.id,
              userId: props.userId,
              userGroupId: props.userGroupId
            }
          });
        }

      },

      roleMaps: {
        service: '',

        list: function(props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        detail: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        },

        remove: function(props) {
          return $http({
            method: 'delete',
            url: this.service,
            data: props.ids
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: [{
              roleId: props.roleId,
              userGroupId: props.userGroupId
            }]
          });
        },

        batchCreate: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: props.mappings
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service,
            data: {
              id: props.id,
              roleId: props.roleId,
              userGroupId: props.userGroupId
            }
          });
        }

      }

    };

}]);